import PropTypes from 'prop-types';
import React, {useState, useEffect} from 'react';
import {requestMapper} from 'selectors/RequestSelector';
import { connect } from 'react-redux';
import HeaderView from './HeaderView2';
import SidebarView from './SidebarView2';

import { themeSelector } from '../design/theme';
import { makeStyles, ThemeProvider } from '@material-ui/core/styles';
import clsx from 'clsx';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import MuiErrorBanner from './Components/MuiErrorBanner';

import Zendesk from './Components/Zendesk';

import { getLanguageDictionary } from '../lib/helpers';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    width: '100%',
    flexGrow: 1
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarSpacer: theme.mixins.toolbar,
  grid: {
    margin: 0,
    width: 'calc(100% - 220px)'
  },
  pageTitle: {
    margin: theme.spacing( 0, 1, 0, 2),
    verticalAlign: 'center',
    display: 'inline-block',
  },
  pageSubTitle: {
    borderLeft: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(1, 3, 0),
  },
  pageTitleDivider: {
    margin: theme.spacing(1, 0, 0, 0),    
  },
  gridItem: {
    width: '100%'
  }
}));

const language = getLanguageDictionary('en')

const darkTheme = 'shadow'
const lightTheme = 'default'

const PageView = (props) => {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)')
  const { ChildView, payload = {} } = props;
  const classes = useStyles();
  const [navType, setNavType] = useState('left') /* eslint-disable-line */
  const [theme, setTheme] = useState(themeSelector(props.theme || 'default'))

  // if the user changes their theme
  // if theme selection is auto, handle it
  // else set the theme to the selection
  useEffect(() => {
    let isThemeAuto = props.theme === 'auto'

    let theme = (isThemeAuto && prefersDarkMode) ? darkTheme :
      (isThemeAuto && !prefersDarkMode) ? lightTheme : props.theme ? props.theme : 'default'

    setTheme(themeSelector(theme))
  }, [props.theme, prefersDarkMode])

  var title, description = false
  if (language.pages[props.payload.toplevel] && language.pages[props.payload.toplevel][props.payload.secondlevel]) {
    var { title, description } = language.pages[props.payload.toplevel][props.payload.secondlevel] /* eslint-disable-line */
  }

  return (
    <React.Fragment>
      { <Zendesk /> }
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className={classes.root}>
          <AppBar className={classes.appBar}>
            <HeaderView {...props} withNav={navType==='top'} />
          </AppBar>
          <SidebarView
            toplevel={props.toplevel}
            secondlevel={props.secondlevel}
            dispatch={props.dispatch}
            orgId={props.orgId}
            payload={payload}
          />
          <Grid
            container
            direction="column"
            spacing={3}
            className={classes.grid}
          >
            <Grid item className={classes.appBarSpacer} />
            {title && (
            <Grid item>
              <Typography className={classes.pageTitle} component="h1" variant="h5">
                {title}
              </Typography>
              {description && (
                <Typography className={clsx(classes.pageTitle, classes.pageSubTitle)} variant="caption">
                  {description}
                </Typography>
              )}
              <Divider className={classes.pageTitleDivider} />
            </Grid>
            )}
            <Grid item className={classes.gridItem}>
              <MuiErrorBanner />
              {/* 
              leaving this announcement component for
              future announcements of new releases
              <MuiAnnouncementDialog /> 
              */}
              <ChildView {...props} {...props.requests} />
            </Grid>
          </Grid>
        </div>
      </ThemeProvider>
    </React.Fragment>
  );
};

PageView.propTypes = {
  ChildView: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({})]),
  payload: PropTypes.shape({}),
  error: PropTypes.shape({
    message: PropTypes.string,
  }),
};

PageView.defaultProps = {
  ChildView: <div />,
  payload: {},
  error: {
    message: '',
  },
};



const mapStateToProps = (state) => {
  return {
    requests: requestMapper(state),
    ready: state.page.ready,
  };
};

export default connect(mapStateToProps)(PageView);
